export type RollSpec = {
	every?: number;
	base_dice?: number;
	dice?: number;
	die?: number;
	base_flat?: number;
	flat?: number;
	cap_dice?: number;
	cap_flat?: number;
};

// Same notation as Spell::DICE.
export const DICE = /^\d+d\d+([+-](\d+d\d+|\d+))*$/;

const cap = (value: number, max?: number) => (max === undefined ? value : Math.min(value, max));

// Port of Spell::Roll#dice_for: m = ceil(level / every), caps apply to the totals.
export function diceFor(spec: RollSpec, level: number): string {
	const m = Math.ceil(level / (spec.every || 1));
	const dice = cap((spec.base_dice ?? 0) + (spec.dice ?? 0) * m, spec.cap_dice);
	const flat = cap((spec.base_flat ?? 0) + (spec.flat ?? 0) * m, spec.cap_flat);

	let expr = dice > 0 ? `${dice}d${spec.die}` : "";
	if (flat !== 0) expr += expr === "" ? String(flat) : `${flat > 0 ? "+" : ""}${flat}`;
	return expr || String(flat);
}
